import compose from 'recompose/compose';
import { connect } from 'react-redux';
import withHandlers from 'recompose/withHandlers';
import { withRouter } from 'react-router';

import {
  getWaitingListCustomersForBarber,
} from '../waitingListCustomers/selectors';
import WaitingListContainer from './WaitingList';
import BarberWaitingList from '../components/BarberWaitingList';
import {
  barberFetchWaitingListCustomers,
  shopFetchWaitingListCustomers,
} from '../waitingListCustomers/actions';
import {
  getBarberUserId,
  getRoleIdType,
  isBarberUser,
} from '../../../auth/selectors';


const fetch = compose(
  withRouter,
  connect(
    (state, ownProps) => {
      const barberId = isBarberUser(state) ? getBarberUserId(state) : ownProps.params.barberId;
      return {
        shopOrBarber: getRoleIdType(state),
        customers: getWaitingListCustomersForBarber(state, barberId, ownProps.currentDate),
      };
    },
    {
      shopFetchWaitingListCustomers,
      barberFetchWaitingListCustomers,
    },
  ),
  withHandlers({
    fetch: props => (date) => {
      if (props.shopOrBarber.type === 'shop') {
        return props.shopFetchWaitingListCustomers(props.shopOrBarber.id, date);
      }
      return props.barberFetchWaitingListCustomers(props.shopOrBarber.id, date);
    },
  }),
);

const BarberWaitingListContainer = WaitingListContainer(fetch)(BarberWaitingList);

export default BarberWaitingListContainer;
